import { createContext, useContext, useState, useCallback } from 'react';

import pl from './pl.json';
import en from './en.json';
import ru from './ru.json';
import ua from './ua.json';

const t = { pl, en, ru, ua };

const LangContext = createContext();

const FLAGS = {
  pl: (
    <svg viewBox="0 0 640 480" className="w-5 h-3.5 rounded-sm shrink-0">
      <path fill="#fff" d="M0 0h640v240H0z"/>
      <path fill="#dc143c" d="M0 240h640v240H0z"/>
    </svg>
  ),
  en: (
    <svg viewBox="0 0 640 480" className="w-5 h-3.5 rounded-sm shrink-0">
      <path fill="#012169" d="M0 0h640v480H0z"/>
      <path fill="#FFF" d="m75 0 244 181L562 0h78v62L400 241l240 178v61h-80L320 301 81 480H0v-60l239-178L0 64V0h75z"/>
      <path fill="#C8102E" d="m424 281 216 159v40L369 281h55zm-184 20 6 35L54 480H0l240-179zM640 0v3L391 191l2-44L590 0h50zM0 0l239 176h-60L0 42V0z"/>
      <path fill="#FFF" d="M241 0v480h160V0H241zM0 160v160h640V160H0z"/>
      <path fill="#C8102E" d="M0 193v96h640v-96H0zM273 0v480h96V0h-96z"/>
    </svg>
  ),
  ru: (
    <svg viewBox="0 0 640 480" className="w-5 h-3.5 rounded-sm shrink-0">
      <path fill="#fff" d="M0 0h640v160H0z"/>
      <path fill="#0039A6" d="M0 160h640v160H0z"/>
      <path fill="#D52B1E" d="M0 320h640v160H0z"/>
    </svg>
  ),
  ua: (
    <svg viewBox="0 0 640 480" className="w-5 h-3.5 rounded-sm shrink-0">
      <path fill="#005BBB" d="M0 0h640v240H0z"/>
      <path fill="#FFD500" d="M0 240h640v240H0z"/>
    </svg>
  ),
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem('lang');
    if (saved) return saved;
    const bl = (navigator.language || '').toLowerCase();
    if (bl.startsWith('ru')) return 'ru';
    if (bl.startsWith('uk') || bl.startsWith('ua')) return 'ua';
    if (bl.startsWith('en')) return 'en';
    return 'pl';
  });

  const changeLang = useCallback((l) => {
    setLang(l);
    localStorage.setItem('lang', l);
  }, []);

  const tr = useCallback((path) => {
    const keys = path.split('.');
    let val = t[lang];
    for (const k of keys) {
      if (!val) return path;
      val = val[k];
    }
    return val || path;
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang: changeLang, t: tr, dict: t[lang], FLAGS }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}

export { FLAGS };
export default t;
